module.exports = __webpack_public_path__ + "img/modal-warning.234205a2.svg";